import { Temporal } from '@js-temporal/polyfill';
import { DateRange } from './types';

export const getDefaultStart = (
  defaultRange: DateRange | undefined,
  valueRange: DateRange | undefined
): Date | null => {
  if (defaultRange?.startDate) {
    return new Date(defaultRange.startDate);
  }
  if (valueRange?.startDate) {
    return new Date(valueRange.startDate);
  }
  return null;
};

export const getDefaultEnd = (defaultRange: DateRange | undefined, valueRange: DateRange | undefined): Date | null => {
  if (defaultRange?.endDate) {
    return new Date(defaultRange.endDate);
  }
  if (valueRange?.endDate) {
    return new Date(valueRange.endDate);
  }
  return null;
};

export const getUserTimezone = () => {
  const stored = localStorage.getItem('last-timezone');
  const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';
  return stored || userTz;
};

export const getAdjustedDate = (timezone: string, onComplete: (date: Date | null) => void) => (date: Date | null) => {
  if (date) {
    const zonedDateTime = Temporal.ZonedDateTime.from({
      timeZone: timezone,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes(),
      second: 0,
    });

    onComplete(new Date(zonedDateTime.toString().split('[')[0]));
  } else {
    onComplete(null);
  }
};
